import { graphql } from "@opensea/graphql"
import { CreateCollectionOfferFlowTableRowFragment } from "./CreateCollectionOfferFlowTableRow.fragment"

export const CreateCollectionOfferFlowTableFragment = graphql(
  `
    fragment CreateCollectionOfferFlowTable on Collection {
      slug
      ...CreateCollectionOfferFlowTableRow
    }
  `,
  [CreateCollectionOfferFlowTableRowFragment],
)
